import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/index'
import introduction from '../components/introduction'
import AboutUs from '../components/AboutUs'
import government from '../components/government'
import enterprise from '../components/enterprise'
import education from '../components/education'
import news from '../components/news'
import ContactUs from '../components/ContactUs'
import NewsDetails from '../components/NewsDetails'
import shuiju from '../components/shuiju'
import quyu from '../components/quyu'
import jinrong from '../components/jinrong'
import xiangmu from '../components/xiangmu'
import zhaopin from '../components/zhaopin'
import kaoshi from '../components/kaoshi'
import dianxin from '../components/dianxin'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      meta: {
        title: '首页',
      },
      component: Index
    },
    {
      path: '/ProductIntroduction',
      name: 'introduction',
      meta: {
        title: '产品介绍',
      },
      component: introduction
    },
    {
      path: '/AboutUs',
      name: 'AboutUs',
      meta: {
        title: '关于我们',
      },
      component: AboutUs
    },
    {
      path: '/GovernmentData',
      name: 'government',
      meta: {
        title: '行业聚焦',
      },
      component: government
    },
    {
      path: '/EnterpriseData',
      name: 'enterprise',
      meta: {
        title: '行业聚焦',
      },
      component: enterprise
    },
    {
      path: '/EducationTraining',
      name: 'education',
      meta: {
        title: '行业聚焦',
      },
      component: education
    },
    {
      path: '/shuiju',
      name: 'shuiju',
      meta: {
        title: '行业聚焦',
      },
      component: shuiju
    },
    {
      path: '/quyu',
      name: 'quyu',
      meta: {
        title: '行业聚焦',
      },
      component: quyu
    },
    {
      path: '/jinrong',
      name: 'jinrong',
      meta: {
        title: '行业聚焦',
      },
      component: jinrong
    },
    {
      path: '/xiangmu',
      name: 'xiangmu',
      meta: {
        title: '行业聚焦',
      },
      component: xiangmu
    },
    {
      path: '/zhaopin',
      name: 'zhaopin',
      meta: {
        title: '行业聚焦',
      },
      component: zhaopin
    },
    {
      path: '/kaoshi',
      name: 'kaoshi',
      meta: {
        title: '行业聚焦',
      },
      component: kaoshi
    },
    {
      path: '/dianxin',
      name: 'dianxin',
      meta: {
        title: '行业聚焦',
      },
      component: dianxin
    },
    {
      path: '/News',
      name: 'news',
      meta: {
        title: '最新资讯',
      },
      component: news
    },
    {
      path: '/NewsDetails',
      name: 'NewsDetails',
      meta: {
        title: '最新资讯',
      },
      component: NewsDetails
    },
    {
      path: '/ContactUs',
      name: 'ContactUs',
      meta: {
        title: '联系我们',
      },
      component: ContactUs
    },
    
  ]
})
